import { track, trackKeyGrowthEvent } from '@mc/track-event'

export const trackContactSalesClicked = (pageSource: string) => {
  track('Contact Sales Clicked', {
    page_source: pageSource,
    location: 'mc_at_work_section',
  })
}

export const trackEnterpriseLearnMoreClicked = (pageSource: string) => {
  track('Enterprise Learn More Clicked', {
    page_source: pageSource,
    location: 'mc_at_work_section',
  })
}

export const trackMAWCTAViewed = (pageSource: string) => {
  trackKeyGrowthEvent('MAW CTA Viewed', {
    page_source: pageSource,
  })
}
